import { useMutation } from "@tanstack/react-query";

import { useCrmEnrichmentJobCache } from "../../hooks/useCrmEnrichmentJobCache";
import type { ICrmEnrichmentAPIService } from "../../services/api/types";
import type { CrmEnrichmentJob, CrmEnrichmentJobRenameDTO } from "../../types/types";
import type { ICrmEnrichmentQueryKeyFactory } from "../key-factory/types";

type MutationDependencies = {
    readonly apiService: ICrmEnrichmentAPIService;
    readonly queryKeys: ICrmEnrichmentQueryKeyFactory;
    readonly onSuccessCallback?: (data: CrmEnrichmentJob, dto: CrmEnrichmentJobRenameDTO) => void;
};

export const useCrmEnrichmentJobRenameMutation = ({
    apiService,
    queryKeys,
    onSuccessCallback,
}: MutationDependencies) => {
    const { updateExistingJobInCache } = useCrmEnrichmentJobCache(queryKeys);

    return useMutation<CrmEnrichmentJob, unknown, CrmEnrichmentJobRenameDTO>({
        mutationFn: apiService.renameJob,
        onSuccess(data, dto) {
            updateExistingJobInCache(data);
            onSuccessCallback?.(data, dto);
        },
    });
};
